import React from 'react';

const Teaser = ({teaserData, tabIndex}: any) => {

  // check for html soft hypen and set them to unicode
  const getItemLabel = (textRef:string) => {
    if(textRef !== undefined){
      textRef = textRef.replaceAll('&shy;', '\u00AD');
    }
    return textRef;
  };

  return (
    <>
      {teaserData.headline &&
      <div className="nav-group-col-wrapper">
        <div>
          <div className='teaser teaser--small teaser--fullwidth'>
            <div className="teaser__item">
            {(teaserData.image && teaserData.url) &&
                <div className="teaser__item-media">
                  <a href={teaserData.url} aria-hidden="true" tabIndex={-1}>
                    <picture>
                      <source media="(min-width: 1280px)" srcSet={teaserData.image} />
                      <source media="(min-width: 960px)" srcSet={teaserData.image} />
                      <source media="(min-width: 840px)" srcSet={teaserData.image} />
                      <source media="(min-width: 480px)" srcSet={teaserData.image} />
                      <img src={teaserData.image} srcSet={teaserData.image} alt={teaserData.imageAlt} />
                    </picture>
                  </a>
                </div>
              }
              <div className="teaser__text">
                {teaserData.headline &&
                  <strong className="teaser__headline">{getItemLabel(teaserData.headline)}</strong>
                }
                {(teaserData.linkText && teaserData.url) &&
                  <a href={teaserData.url} aria-label={getItemLabel(teaserData.headline)} className={`link link--notrack ${teaserData.linkType}`} tabIndex={tabIndex}>
                    <span className="ic-arrowRight" aria-hidden="true"/>
                    <span className="link__name">
                      <span className="link__name-inner">
                        <span className="link__name-text">{getItemLabel(teaserData.linkText)}</span>
                      </span>
                    </span>
                  </a>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
      }
    </>
  )
};

export default Teaser;
